let PRODUCT_OBJECT = {
  blog: "",
  magnet: "",
  magnetThanks: "",
  productSales: "",
  productOrder: "",
  productThanks: "",
  name: "",
}

const MODEL_SMART_AUDIENCE = {
  name: "",
  isPublished: false,
  spec: {
    pixelId: null,
    pageId: null,
  },
  products: [{ ...PRODUCT_OBJECT }],
}

export { MODEL_SMART_AUDIENCE, PRODUCT_OBJECT }
